import { Injectable }    from '@angular/core';
import { environment } from 'src/environments/environment';
import { RequestItemsListViewModel } from 'src/common';
import {SearchModel, SearchResultModel} from 'src/common';
import {HttpClient} from '@angular/common/http';



const localApiUrl = `${environment.apiUrl}/RequestItemsListView`;

@Injectable()
export class RequestItemsListViewService {

  constructor(private http: HttpClient) { }

  search(search: SearchModel): Promise<SearchResultModel<RequestItemsListViewModel>> {
      return this.http.post<SearchResultModel<RequestItemsListViewModel>>(`${localApiUrl}/Search`, search).toPromise();
  }

  getAll(): Promise<RequestItemsListViewModel[]> {
	return this.http.get<RequestItemsListViewModel[]>(`${localApiUrl}/All`).toPromise();
  }

  getById(id: number): Promise<RequestItemsListViewModel> {
    return this.http.get<RequestItemsListViewModel>(`${localApiUrl}/Details/${id}`).toPromise();
  }

  delete(id: number): Promise<void> {
	return this.http.get<void>(`${localApiUrl}/Delete/${id}`).toPromise();
  }

  save(model: any): Promise<void> {
    return this.http.post<void>(`${localApiUrl}/Save`, model).toPromise();
  }


  // custom-start


  getParamsForInput(requestId): Promise<RequestItemsListViewModel[]> {
    return this.http.get<RequestItemsListViewModel[]>(`${environment.apiUrl}SupplierOffer/GetParamsForInput?requestId=${requestId}`).toPromise();
  }

  // custom-end

}



